/**
 * @Author: zangkang
 * @Date:   2018-02-05T10:47:18+08:00
 * @Last modified by:   zangkang
 * @Last modified time: 2018-02-05T10:47:18+08:00
 */

import _util from '../../utils/';

const certificateManageService = {
    fetchCertificateList (params, resolve, reject) {
      _util.request({
        url: '/api/HRCertificate/Get',
        params: params,
        success: resolve,
        error: reject
      })
    },
    fetchCertificateEmployeeList(gets, resolve, reject) {
        _util.request({
            url: '/api/HRCertificate/Get',
            params: gets,
            success: resolve,
            error: reject
        })
    },

    createCertificate (data, resolve, reject) {
    	_util.request({
            url: '/api/HRCertificate/Post',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },

    updateCertificate (data, resolve, reject) {
    	_util.request({
            url: '/api/HRCertificate/Put',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },

    deleteCertificate (data, resolve, reject) {
    	_util.request({
            url: '/api/HRCertificate/Delete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },

    setAlarm (data, resolve, reject) {
    	_util.request({
            url: '/api/HRCertificate/Delete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },

    exportCertificateList (data, resolve, reject) {
        _util.request({
            url: '/api/HRCertificate/ExportCertificate',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
    CertificatePost(posts, resolve, reject) {
        _util.request({
            url: '/api/HRAlertSetting/CertificatePost',
            method: 'POST',
            data: posts,
            success: resolve,
            error: reject
        })        
    },
    exportCertificate(resolve, reject) {
        _util.request({
            url: '/api/HRCertificate/Export',
            success: resolve,
            error: reject
        })
    },
    downloadTemplate(resolve, reject) {
        _util.request({
            url: '/api/HRCertificate/GetImportTemplate',
            success: resolve,
            error: reject
        });
    },
    importCertificate(posts, resolve, reject) {
        _util.request({
            url: '/api/HRCertificate/Import',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        })
    },
}


export default certificateManageService;



// WEBPACK FOOTER //
// ./src/services/EmployeeManagement/certificate-manage-service.js